export class CashierService {}

export const cashierService = new CashierService();
